import { Grid } from '@material-ui/core';
import React from 'react';
import { ITenderGroup } from 'src/common/interfaces/dtos/ITenderGroup';
import { styles } from 'src/middle-area/tabs/middle-area-styles';
import TabPanel from 'src/tab-panel/tab-panel';
import TenderGroupView from './tender-group-view';

const TenderingTabPanels: React.FC<TenderingTabPanelsProps> = ({
  tenderGroups,
  tabValue,
  startingIndex,
}): JSX.Element => {
  const classes = styles();

  return (
    <>
      {tenderGroups.map((tenderGroup, index): JSX.Element | undefined => {
        const tabIndex = startingIndex + index;
        if (tabValue !== tabIndex) {
          return undefined;
        } else {
          return (
            <TabPanel
              key={tenderGroup.name}
              value={tabValue}
              index={startingIndex + index}
              data-testid={`${tenderGroup.name}--tab`}
            >
              <Grid
                container
                direction='column'
                className={`fullHeight ${classes.panel}`}
                data-testid={`tender-group-${tabIndex}-tab-panel`}
              >
                <TenderGroupView tenderGroup={tenderGroup} />
              </Grid>
            </TabPanel>
          );
        }
      })}
    </>
  );
};

interface TenderingTabPanelsProps {
  tenderGroups: ITenderGroup[];
  tabValue: number;
  startingIndex: number;
}

export default TenderingTabPanels;
